import { render, staticRenderFns } from "./FaqItemList.vue?vue&type=template&id=3428c32c&scoped=true"
import script from "./FaqItemList.vue?vue&type=script&lang=js"
export * from "./FaqItemList.vue?vue&type=script&lang=js"
import style0 from "./FaqItemList.vue?vue&type=style&index=0&id=3428c32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3428c32c",
  null
  
)

export default component.exports